import Vue from 'vue'
import App from './App.vue'
import Storage from 'vue-ls'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import store from './store'
import axios from 'axios'

Vue.use(ElementUI)
Vue.use(axios)
Vue.use(Storage, {
  namespace: 'insurance__', // 你的应用唯一命名空间
  name: 'ls', // Vue.[ls] 变量名称，默认 'ls'
  storage: 'local' // 存储名称 session, local, memory
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js